import templateUrl from './generic-form-messages.html';

/**
 * Directive that specifies where to display generic form errors.
 * Populate by setting formCtrl.setFormErrors(array).
 */
export default /* @ngInject */ function($timeout) {
    return {
        templateUrl: templateUrl,
        require: '^form',
        link: function(scope, element, attrs, formCtrl) {
            // Create proprietary functions on the form that
            // can be called to populate our template.

            formCtrl.setFormSuccess = function(message, hideTime=false) {
                scope.formSuccess = message;
                scope.errors = null;

                if (hideTime){
                    $timeout(() => {
                        scope.formSuccess = null;
                    }, hideTime);
                }
            };

            formCtrl.setFormErrors = function(errors=[]) {
                scope.errors = errors;
                scope.formSuccess = null;
            };
        }
    };
}



// WEBPACK FOOTER //
// ./forms/directives/generic-form-messages.js